import React from 'react';

import {
  Breakpoints,
  TextCustom,
  TextAppearance,
  TextSize,
  TextWeight,
  TextColor,
  TextLineHeight,
  Spinner,
  ThemeProvider,
} from '@vw-marketing/us-components';

import { applyTextTransformations } from '../../../../shared/utils/applyTextTransformations';
import { StyledLoadingContainer } from './deactivate-account-loading-styles';

interface DeactivateAccountLoadingViewProps {
  translationHandler: (key: string) => string;
}

export const DeactivateAccountLoadingView = ({ translationHandler }: DeactivateAccountLoadingViewProps) => (
  <ThemeProvider theme="main">
    <StyledLoadingContainer>
      <TextCustom
        appearance={TextAppearance.copy200}
        style={{
          [Breakpoints.default]: {
            fontSize: TextSize.TextSize20,
            fontWeight: TextWeight.bold,
            color: TextColor.primary,
            lineHeight: TextLineHeight.TextLineHeight32,
          },
          [Breakpoints.b1920]: {
            fontSize: TextSize.TextSize24,
            fontWeight: TextWeight.bold,
            color: TextColor.primary,
            lineHeight: TextLineHeight.TextLineHeight36,
          },
        }}
      >
        {applyTextTransformations(
          translationHandler('accountSettings.deactivate.myvwaccount.confirmation.label'),
          ['myVW'],
        )}
      </TextCustom>
      <Spinner variant='x-large' />
    </StyledLoadingContainer>
  </ThemeProvider>
);